<template>
  <th
    :key="data.key || data.text"
    :class="[
      'column',
      data.sortable ? 'sortable' : '',
      asc ? 'asc' : 'desc',
      data.orderBy === orderBy ? 'active' : '',
      data.align ? 'text-xs-' + data.align : '',
    ]"
    :width="data.width"
    :title="titleText"
    @click="onClick"
  >
    {{ data.text }}
    <v-icon small v-if="data.sortable">arrow_upward</v-icon>
    <span class="d-block" :class="thFooterClass">{{ thFooterText }}</span>
  </th>
</template>

<script>
export default {
  name: 'TableHeader',
  props: {
    data: {
      type: Object,
      required: true,
    },
    asc: {
      required: true,
    },
    orderBy: {
      required: true,
    },
    thFooterClass: {
      type: String,
      default: '',
    },
    thFooterText: {
      type: String,
      default: '',
    },
    titleText: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      this.$emit('sort', this.data)
    },
  },
}
</script>
